module.exports = __webpack_public_path__ + "img/down-left.f4785e11.svg";